import { HttpResponse } from '@angular/common/http';
import { parse } from '@tinyhttp/content-disposition';

export class FileResponse {
  content: Blob;
  fileName: string;
  fileSize?: number;
  fileLastMod?: Date;

  public static parseResponse(response: HttpResponse<Blob>): FileResponse {
    return {
      content: response.body,
      fileName: String(
        parse(response.headers.get('content-disposition')).parameters?.filename,
      ),
      fileSize: Number(response.headers.get('X-File-Size')),
      fileLastMod: new Date(response.headers.get('X-File-LastMod')),
    };
  }
}
